<template>
  <div class="applu-special-price">
    <div class="breadcrumb" style="background: #fff">申请特殊价格</div>
    <div class="third-title"><span> SKU组价格信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="80px">
        <el-form-item label="平台号:">{{ basicInfo.platfotmNum }}</el-form-item>
        <el-form-item label="申请价格:">
          <el-button round @click="changePrice">修改</el-button>
        </el-form-item>
        <el-form-item label="申请方式:" v-if="isShow">
          <el-radio v-model="basicInfo.applyWay" label="APPLY_BASE">基础P申请</el-radio>
          <el-radio v-model="basicInfo.applyWay" label="APPLY_DISCOUNT">整体折扣</el-radio>
        </el-form-item>
        <el-form-item>
          <div style="width: auto" v-if="basicInfo.applyWay === '1'">
            <el-table :data="specialPriceData" border width="100%">
              <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
              <el-table-column min-width="100px" label="基础P数">
                <template v-slot="scope">
                  <span>{{ scope.row.page }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="maxpage" min-width="100px" label="最大P数"> </el-table-column>
              <el-table-column prop="apage" min-width="150px" label="一次增加P数"></el-table-column>
              <el-table-column prop="price" min-width="150px" label="基础P平台价格"></el-table-column>
              <el-table-column prop="aprice" min-width="150px" label="增加一次平台价格"> </el-table-column>
              <el-table-column min-width="200px" label="申请基础P数价格">
                <template v-slot="scope">
                  <el-input v-model="scope.row.applyPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="width: 402px" v-if="basicInfo.applyWay === '2'">
            <el-table :data="allPrice" border>
              <el-table-column label="SKU名称" min-width="200px" prop="skuName"></el-table-column>
              <el-table-column min-width="200px" label="申请折扣">
                <template v-slot="scope">
                  <el-input v-model="scope.row.discount" class="color-blue"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="returnPage">返回</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
export default {
  name: 'applu-special-price',
  components: {
    CombinedDialog
  },
  data () {
    return {
      isShow: false,
      basicInfo: {
        platfotmNum: '1111111',
        applyWay: '1'
      },
      specialPriceData: [{
        skuName: 'ertrt',
        page: 'dfgdfg',
        maxpage: '',
        apage: '',
        price: '',
        aprice: '',
        applyPrice: ''
      }],
      allPrice: [{
        skuName: '545',
        discount: '3'
      }]
    }
  },
  methods: {
    changePrice () {
      this.isShow = true
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
 <style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
